import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";

import { IUser } from "Auth/types";

const projectId = "qnq0bn/tourmanagement";

const isLogRocketEnabled = () =>
  process.env.REACT_APP_ENV &&
  ["production", "staging"].includes(process.env.REACT_APP_ENV);

// We have a qnq0bn/tourmanagement-staging-gd7o1 project to differentiate
// between the environments
const getLogRocketProjectId = () =>
  process.env.REACT_APP_ENV === "staging" ? `${projectId}-staging-gd7o1` : projectId;

export class LogRocketService {
  static init = () => {
    if (isLogRocketEnabled()) {
      LogRocket.init(getLogRocketProjectId());
      setupLogRocketReact(LogRocket);
    }
  };

  static setUser = (user: IUser | null) => {
    if (user && isLogRocketEnabled()) {
      LogRocket.identify(user.id, {
        name: user.username,
        email: user.attributes.email,
      });
    }
  };
}
